import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Radio,
  Typography,
  CircularProgress,
  Box,
  Alert,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";

const PrinterSelectionModal = ({
  open,
  onClose,
  availablePrinters,
  selectedPrinter,
  loadingPrinters,
  onSelectPrinter,
  onDetectPrinters,
  type = "label",
  autoPrintEnabled = false,
}) => {
  const [localSelectedPrinter, setLocalSelectedPrinter] = useState(
    selectedPrinter?.name || ""
  );
  const [autoprint, setAutoprint] = useState(autoPrintEnabled);

  // Atualiza o estado local quando o modal abre ou quando selectedPrinter muda
  useEffect(() => {
    if (open && selectedPrinter) {
      setLocalSelectedPrinter(selectedPrinter.name);
    }
  }, [open, selectedPrinter]);

  const handleSelectPrinter = () => {
    const printer = availablePrinters.find(
      (p) => p.name === localSelectedPrinter
    );
    if (printer) {
      onSelectPrinter(printer, autoprint);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <PrintIcon />
          <Typography variant="h6">Selecionar Impressora</Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <List>
          {availablePrinters.length === 0 && !loadingPrinters && (
            <Alert severity="info" sx={{ width: "100%" }}>
              Nenhuma impressora encontrada. Conecte uma impressora e tente
              novamente.
            </Alert>
          )}

          {loadingPrinters ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
              <CircularProgress size={24} />
            </Box>
          ) : (
            availablePrinters.map((printer) => (
              <ListItem key={printer.name} disablePadding>
                <ListItemButton
                  onClick={() => setLocalSelectedPrinter(printer.name)}
                  selected={localSelectedPrinter === printer.name}
                >
                  <ListItemIcon>
                    <Radio
                      edge="start"
                      checked={localSelectedPrinter === printer.name}
                      tabIndex={-1}
                      disableRipple
                      color="primary"
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={printer.name}
                    secondary={printer.status}
                  />
                </ListItemButton>
              </ListItem>
            ))
          )}
        </List>

        {type !== "order" && (
          <Box sx={{ mt: 3, pt: 2, borderTop: "1px solid #e0e0e0" }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={autoprint}
                  onChange={(e) => setAutoprint(e.target.checked)}
                  color="primary"
                />
              }
              label={
                <Typography variant="body2">
                  Impressão automática (imprimir etiqueta automaticamente ao
                  encontrar a nota fiscal)
                </Typography>
              }
            />
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={handleSelectPrinter}
          disabled={!localSelectedPrinter}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrinterSelectionModal;
